var _g, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMetricIconIncomplete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16953_417)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.00390625,
    y: -0.00390625,
    width: 32,
    height: 32,
    rx: 5.81818,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.746094,
    y: 0.746094,
    width: 30.5,
    height: 30.5,
    rx: 5.06818,
    stroke: "#1F6DD4",
    strokeOpacity: 0.1,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_16953_417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9961 15.9961L24.9961 6.99609",
    stroke: "#1F6DD4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6985 8.36565C9.7873 9.55641 8.39268 11.4211 7.79049 13.5909C7.1883 15.7606 7.4224 18.0774 8.44649 20.0828C9.47058 22.0882 11.2101 23.6362 13.3208 24.4205C15.4315 25.2049 17.7598 25.1685 19.845 24.3185C21.9301 23.4684 23.6203 21.8668 24.5812 19.8303",
    stroke: "#1F6DD4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7416 11.6129C13.737 11.9254 12.8736 12.58 12.3015 13.4629C11.7294 14.3459 11.4847 15.4014 11.6101 16.446C11.7354 17.4906 12.2228 18.4583 12.9875 19.1808C13.7523 19.9034 14.746 20.3351 15.7961 20.4011C16.8461 20.467 17.886 20.1629 18.7351 19.5417C19.5843 18.9204 20.1888 18.0213 20.4438 17.0006",
    stroke: "#1F6DD4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8564 15.8174L15.8172 6.85678",
    stroke: "#1F6DD4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.296094,
    y: 0.296094,
    width: 31.4,
    height: 31.4,
    rx: 4.7,
    stroke: "#1F6DD4",
    strokeWidth: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16953_417"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.00390625,
    y: -0.00390625,
    width: 32,
    height: 32,
    rx: 5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_16953_417"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(3.99609 3.99609)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricIconIncomplete);
export default __webpack_public_path__ + "static/media/MetricIconIncomplete.842bf063a2f33e2f4485bee857544d76.svg";
export { ForwardRef as ReactComponent };